export const initTestimonialSlider = (instance) => {
	const block = instance.el.closest('.em-testimonial-slider');

	if (block) {
		const slideParent = block.querySelector('.em-testimonial-slider__quotes .splide__list');
		const contents = [...instance.el.querySelectorAll('.em-testimonial-slide__content')];

		if (slideParent && contents.length) {
			// Add the slides to the slider.
			slideParent.innerHTML = contents.map((contents) => {
				// Wrap the content in a slide.
				const html = `<div class="splide__slide">${contents.outerHTML}</div>`;
				// Remove the original content.
				contents.remove();
				// Return the new slide.
				return html;
			}).join('');
		}
	}
};
